module.exports = ":host{display:flex;flex-direction:column;height:100%}mat-drawer-container{height:100%}mat-drawer-content{padding:20px}\n"